var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "homePageWarp" },
    [
      _c("navHeader"),
      _vm._v(" "),
      _c("div", { staticClass: "main" }, [_c("router-view")], 1),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "countryLogin",
          attrs: {
            visible: _vm.loginDialog,
            "modal-append-to-body": true,
            "close-on-click-modal": false,
            width: "20%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.loginDialog = $event
            },
          },
        },
        [
          _c("div", { staticClass: "l_W" }, [
            _vm.boxLoginShow
              ? _c(
                  "div",
                  { staticClass: "boxLogin" },
                  [
                    _c("h5", { staticClass: "infoLogin" }, [
                      _vm._v("账号登录"),
                    ]),
                    _vm._v(" "),
                    _vm.phoneTipShow
                      ? _c("p", { staticClass: "phoneTip" }, [
                          _c("i", { staticClass: "el-icon-warning-outline" }),
                          _vm._v(" 请输入手机号\n        "),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form",
                      {
                        ref: "userMsg",
                        attrs: { model: _vm.userMsg, rules: _vm.userRules },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "username" } },
                          [
                            _c("el-input", {
                              attrs: {
                                size: "medium",
                                "prefix-icon": "el-icon-mobile-phone",
                                placeholder: "请输入账号",
                              },
                              model: {
                                value: _vm.userMsg.username,
                                callback: function ($$v) {
                                  _vm.$set(_vm.userMsg, "username", $$v)
                                },
                                expression: "userMsg.username",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "password" } },
                          [
                            _c("el-input", {
                              attrs: {
                                "prefix-icon": "el-icon-lock",
                                type: "password",
                                placeholder: "请输入密码",
                              },
                              model: {
                                value: _vm.userMsg.password,
                                callback: function ($$v) {
                                  _vm.$set(_vm.userMsg, "password", $$v)
                                },
                                expression: "userMsg.password",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "loginBtn",
                        attrs: { loading: _vm.loading, type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.login("userMsg")
                          },
                        },
                      },
                      [_vm._v("登录")]
                    ),
                    _vm._v(" "),
                    _c("br"),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "agreementBox" },
              [
                _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.checked,
                      callback: function ($$v) {
                        _vm.checked = $$v
                      },
                      expression: "checked",
                    },
                  },
                  [_vm._v("我已阅读并同意")]
                ),
                _vm._v(" "),
                _c(
                  "el-link",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.openUserService("/userService")
                      },
                    },
                  },
                  [_vm._v("《国家职业教育智慧教育平台用户协议》")]
                ),
                _vm._v(" "),
                _c(
                  "el-link",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.openUserService("/userServiceTwo")
                      },
                    },
                  },
                  [_vm._v("《国家职业教育智慧教育平台隐私协议》")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "xz",
          attrs: {
            visible: _vm.isShow,
            "modal-append-to-body": true,
            "close-on-click-modal": false,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShow = $event
            },
          },
        },
        [
          _c("h5", [_vm._v("欢迎登录，选择进入系统")]),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(_vm.xzList, function (i, j) {
              return _c(
                "li",
                {
                  key: j,
                  on: {
                    click: function ($event) {
                      return _vm.tiaozhuan(i.url)
                    },
                  },
                },
                [_vm._v("\n        " + _vm._s(i.name) + "\n      ")]
              )
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footerWarp" }, [
      _c("div", { staticClass: "footer" }, [
        _c("img", {
          staticClass: "footerBadge",
          attrs: {
            src: require("@/assets/img/footer-conac-blue.png"),
            alt: "事业单位",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "footerInfo" }, [
          _c("p", { staticClass: "footerMeta" }, [
            _c("span", [_vm._v("主办单位:北京市教育委员会")]),
            _vm._v(" "),
            _c("span", [_vm._v("承办单位:北京市数字教育中心")]),
            _vm._v(" "),
            _c("span", [_vm._v("ICP备案/许可证号：京ICP备05039435号-5")]),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "footerPolice" }, [
            _c("img", {
              staticClass: "policeIcon",
              attrs: {
                src: require("@/assets/img/footer-police-beian.jpg"),
                alt: "",
              },
            }),
            _vm._v("\n          京公网安备 11010202010352号\n        "),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }